<template>
  <section class="py-5">
    <div class="container">
      <div v-if="items && items.length" class="row justify-content-center">
        <div
          v-for="(item, index) in items"
          :key="item.id"
          class="col-md-4 mb-3 text-center"
        >
          <div class="card" @click="() => showImg(index)">
            <img
              :src="
                'https://cdn.statically.io/img/inv.zoinix.com/f=auto,q=50/' +
                item.image.replace('https://inv.zoinix.com/', '')
              "
              loading="lazy"
              class="card-img-top"
            />
            <div class="card-body">
              <h5 class="card-title">{{ item.title }}</h5>
            </div>
          </div>
        </div>
        <vue-easy-lightbox
          :visible="visible"
          :imgs="
            'https://cdn.statically.io/img/inv.zoinix.com/f=auto/' +
            items[index].image.replace('https://inv.zoinix.com/', '')
          "
          :index="index"
          @hide="handleHide"
        ></vue-easy-lightbox>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import VueEasyLightbox from "vue-easy-lightbox";

export default {
  components: { VueEasyLightbox },
  data() {
    return {
      items: [],
      visible: false,
      index: 0,
    };
  },
  async created() {
    try {
      const response = await axios.get(`/porto/portos`);
      this.items = response.data;
    } catch (e) {
      console.log(e);
      this.errors.push(e);
    }
  },
  methods: {
    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.card {
  cursor: pointer;
}
</style>
